module.exports = __webpack_public_path__ + "img/19.45f4b939.svg";